<main class="admin-rule-add-wrapper">
  <header>
    <h1 class="mb-4">Dodawanie nowej wersji regulaminu</h1>
  </header>
  <section>
    <form [formGroup]="formGroup()">
      <p-card class="mb-4">
        <div class="w-full flex flex-col gap-5">
          <div class="text-xl font-semibold">Dane podstawowe</div>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div class="flex flex-col gap-2">
              <label for="rule-date-create" class="font-semibold">
                Data utworzenia
              </label>
              <p-date-picker
                inputId="rule-date-create"
                class="w-full customDatePicker"
                dateFormat="yy-mm-dd"
                [showTime]="true"
                hourFormat="24"
                [readonlyInput]="true"
                [showIcon]="true"
                [iconDisplay]="'input'"
                appendTo="body"
                formControlName="dataUtworzenia"
              ></p-date-picker>
            </div>
            <div class="flex flex-col gap-2">
              <label
                for="rule-date-from"
                appRequiredLabel="dataOd"
                class="font-semibold"
                >Data początku obowiązywania</label
              >
              <p-date-picker
                inputId="rule-date-from"
                class="w-full customDatePicker"
                dateFormat="yy-mm-dd"
                [showClear]="true"
                [readonlyInput]="true"
                [showIcon]="true"
                [iconDisplay]="'input'"
                [formControl]="formGroup().controls.dataOd"
                [showTime]="true"
                [hourFormat]="'24'"
                appendTo="body"
                appControlError
              ></p-date-picker>
            </div>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div class="flex flex-col gap-2">
              <label for="rule-date-to" class="font-semibold">
                Data końca obowiązywania
              </label>
              <p-date-picker
                inputId="rule-date-to"
                class="w-full customDatePicker"
                dateFormat="yy-mm-dd"
                [showTime]="true"
                hourFormat="24"
                [readonlyInput]="true"
                [showIcon]="true"
                [iconDisplay]="'input'"
                appendTo="body"
                formControlName="dataDo"
              ></p-date-picker>
            </div>
          </div>
        </div>
      </p-card>
      <p-card class="mb-4">
        <div class="w-full flex flex-col gap-5">
          <label
            for="rule-content"
            appRequiredLabel="tresc"
            class="text-xl font-semibold"
            >Treść regulaminu</label
          >
          <p-editor
            inputId="rule-content"
            [style]="{ height: '320px' }"
            [formControl]="formGroup().controls.tresc"
            class="rule-editor"
            appControlError
          >
            <ng-template #header>
              <span class="ql-formats">
                <select class="ql-size" aria-label="Rozmiar czcionki">
                  <option value="small">Mała</option>
                  <option selected>Średnia</option>
                  <option value="large">Duża</option>
                </select>
                <button
                  type="button"
                  class="ql-bold"
                  aria-label="Pogrubienie"
                ></button>
                <button
                  type="button"
                  class="ql-italic"
                  aria-label="Pochylenie"
                ></button>
                <button
                  type="button"
                  class="ql-underline"
                  aria-label="Podkreślenie"
                ></button>
                <select
                  type="button"
                  class="ql-color"
                  aria-label="Kolor tekstu"
                ></select>
                <button
                  type="button"
                  class="ql-list"
                  value="ordered"
                  aria-label="Lista numeryczna"
                ></button>
                <button
                  type="button"
                  class="ql-list"
                  value="bullet"
                  aria-label="Lista wypunktowana"
                ></button>
                <select
                  type="button"
                  class="ql-align"
                  aria-label="Wyśrodkowanie tekstu"
                ></select>
              </span>
            </ng-template>
          </p-editor>
        </div>
      </p-card>
    </form>
    <section>
      <div class="flex justify-end gap-3">
        <p-button
          type="button"
          label="Anuluj"
          styleClass="customInfoButton outlined"
          (onClick)="onCancel()"
          [disabled]="isSubmitting()"
        ></p-button>
        <p-button
          type="button"
          label="Dodaj"
          styleClass="customInfoButton"
          (onClick)="onFormSubmit()"
          [disabled]="isSubmitting()"
        ></p-button>
      </div>
    </section>
  </section>
</main>
